<template>
<div class="chapter">
<div class="inner_page">
<a id="page_v"></a>
<h1 class="toc-title">Contents</h1>
<h2 class="toc"><a href="#/xhtml/04_Acknowledgements"><em class="italic">Acknowledgements</em></a></h2>
<h2 class="toc"><a href="#/xhtml/05_Listofillustrations"><em class="italic">List of Illustrations</em></a></h2>
<h2 class="toc"><a href="#/xhtml/06_Introduction"><em class="italic">Introduction</em></a></h2>
<h2 class="toc2"><span href="#/xhtml/07_Part01" title="Link target outside of Sample"><span class="bold">Part I: The Greek World</span></span></h2>
<h3 class="toc1"><span href="#/xhtml/08_Chapter01" title="Link target outside of Sample"><span class="bold"><span class="space1">Chapter 1</span></span> The Battle of Cunaxa (401 <span class="small-caps">BCE</span>)</span></h3>
<h3 class="toc1"><span href="#/xhtml/09_Chapter02" title="Link target outside of Sample"><span class="bold"><span class="space1">Chapter 2</span></span> The Battle of Issus (333 <span class="small-caps">BCE</span>)</span></h3>
<h2 class="toc2"><span href="#/xhtml/10_Part02" title="Link target outside of Sample"><span class="bold">Part II: The Roman World</span></span></h2>
<h3 class="toc1"><span href="#/xhtml/11_Chapter03" title="Link target outside of Sample"><span class="bold"><span class="space1">Chapter 3</span></span> The Battle of Cannae (216 <span class="small-caps">BCE</span>)</span></h3>
<h3 class="toc1"><span href="#/xhtml/12_Chapter04" title="Link target outside of Sample"><span class="bold"><span class="space1">Chapter 4</span></span> The Sieges of Jerusalem (70 <span class="small-caps">CE</span>) and Masada (72–74 <span class="small-caps">CE</span>)</span></h3>
<h2 class="toc2"><span href="#/xhtml/13_Part03" title="Link target outside of Sample"><span class="bold">Part III: Late Antiquity</span></span></h2>
<h3 class="toc1"><span href="#/xhtml/14_Chapter05" title="Link target outside of Sample"><span class="bold"><span class="space1">Chapter 5</span></span> The Battle of Strasbourg (357 <span class="small-caps">CE</span>)</span></h3>
<h3 class="toc1"><span href="#/xhtml/15_Chapter06" title="Link target outside of Sample"><span class="bold"><span class="space1">Chapter 6</span></span> The Siege of Edessa (544 <span class="small-caps">CE</span>)</span></h3>
<h2 class="toct"><span href="#/xhtml/16_Conclusion" title="Link target outside of Sample"><em class="italic">Conclusion</em></span></h2>
<h2 class="toc"><span href="#/xhtml/17_Notes" title="Link target outside of Sample"><em class="italic">Notes and References</em></span></h2>
<h2 class="toc"><span href="#/xhtml/18_Bibliography" title="Link target outside of Sample"><em class="italic">Bibliography and Further Reading</em></span><a id="page_vi"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?c5028c0a